/* global axios */
// As ações de drip (start/pause/resume/preview/recipients) PRECISAM do axios
// GLOBAL (window.axios = createAxios(axios)), que carrega os headers de auth
// (DeviseTokenAuth). Importar 'axios' cru aqui criava requisições SEM auth -> 401
// -> o front mostrava o genérico "Não foi possível iniciar o disparo" (no corpo do
// 401 vem {errors:[...]} plural, não {error}). ApiClient usa o mesmo global.
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  // Disparo em massa v2 (drip): controles e leitura por campanha.
  start(id) {
    return axios.post(`${this.url}/${id}/start`);
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  preview(id) {
    return axios.get(`${this.url}/${id}/preview`);
  }

  recipients(id) {
    return axios.get(`${this.url}/${id}/recipients`);
  }
}

export default new CampaignsAPI();
